// extracted by mini-css-extract-plugin
export var cancelButton = "_n2-5";
export var content = "_n2-3";
export var createButton = "_n2-6";
export var drawerContainer = "_n2-0";
export var footer = "_n2-2";
export var header = "_n2-1";
export var orderFormColumn = "_n2-4";